import { SummaryItem } from '@web/components/Timesheet/SummaryCards';

export type SummaryDescriptionItem = Extract<SummaryItem, { __typename: 'description' }>;

interface PreviewBillableLabels {
  billable: string;
  nonBillable: string;
}

interface BuildSummaryItemsOptions {
  descriptionItem: SummaryDescriptionItem;
  previewBillableLabels?: PreviewBillableLabels;
  employeeItem?: Extract<SummaryItem, { __typename: 'text' | 'component' }>;
}

const createPreviewBillableItems = ({ billable, nonBillable }: PreviewBillableLabels): SummaryItem[] => [
  {
    __typename: 'preview',
    label: billable,
    value: undefined,
  },
  {
    __typename: 'preview',
    label: nonBillable,
    value: undefined,
  },
];

export const buildSummaryItems = (
  items: SummaryItem[],
  { descriptionItem, previewBillableLabels, employeeItem }: BuildSummaryItemsOptions,
): SummaryItem[] => {
  const [beginDateItem, endDateItem, totalHoursItem, ...remainingItems] = items;
  const summaryItems: SummaryItem[] = [];

  if (employeeItem) {
    summaryItems.push(employeeItem);
  }

  if (beginDateItem) {
    summaryItems.push(beginDateItem);
  }

  if (endDateItem) {
    summaryItems.push(endDateItem);
  }

  summaryItems.push(descriptionItem);

  if (totalHoursItem) {
    summaryItems.push(totalHoursItem);
  }

  if (previewBillableLabels) {
    summaryItems.push(...createPreviewBillableItems(previewBillableLabels));
  }

  summaryItems.push(...remainingItems);

  return summaryItems;
};
